'use strict';

var _ = require('lodash');
var SchedulesFilterByPOSFactory = function SchedulesFilterByPOSFactory(DataFilter) {
  function SchedulesFilterByPOS() {
    DataFilter.call(this, 'market-dashboard', 'markets-and-poses', 2);
  }
  SchedulesFilterByPOS.prototype = Object.create(DataFilter.prototype);
  SchedulesFilterByPOS.prototype.filter = function (data, range) {
    var filtered = [];
    range = range[0];
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var element = data[index];
      if (_.intersection(element.pos, range.pos).length > 0) {
        filtered.push(element);
      }
    }
    return filtered;
  };
  return SchedulesFilterByPOS;
};
SchedulesFilterByPOSFactory.$inject = ['DataFilterFactory'];
module.exports = SchedulesFilterByPOSFactory;